import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "teacher-check-comment"
}
const _hoisted_3 = { class: "who" }

import { format } from 'date-fns'
import { MilestoneTeacherCheck } from '../../../api/v2/models/user_goal'


export default /*@__PURE__*/_defineComponent({
  __name: 'MilestoneTeacherCheck',
  props: {
    check: {},
    part: {}
  },
  setup(__props: any) {



function shortDate(date: Date): string {
  return format(date, 'M/D')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 先生チェック：見出しの横の印（part=\"badge\"）と、先生のコメント（part=\"comment\"） "),
    (__props.check)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.part === 'badge')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["teacher-check-badge", `is-${__props.check.status}`])
              }, [
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.check.status === 'checked' ? 'mdi-check-decagram' : 'mdi-timer-sand'), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                (__props.check.status === 'checked')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[0] || (_cache[0] = _createTextVNode("先生チェック済み", -1 /* CACHED */)),
                      (__props.check.checkedAt)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(shortDate(__props.check.checkedAt)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("先生の確認待ち")
                    ], 64 /* STABLE_FRAGMENT */))
              ], 2 /* CLASS */))
            : (__props.part === 'comment' && __props.check.status === 'checked' && __props.check.comment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    class: "me-1"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-comment-quote-outline", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(__props.check.checkedBy || '先生'), 1 /* TEXT */),
                  _createTextVNode(_toDisplayString(__props.check.comment), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})